/**
 * The commit this bundle was built from. Vite replaces `__APP_VERSION__` when it builds and does not when it
 * serves, so it is checked with `typeof` rather than read - reading an undeclared global throws, and a footer
 * is not worth a blank page. On the dev server this reads "dev".
 */
export const APP_VERSION = typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : 'dev';
